import { render } from "./SubRoute.vue?vue&type=template&id=90b05faa"
import script from "./SubRoute.vue?vue&type=script&lang=js"
export * from "./SubRoute.vue?vue&type=script&lang=js"
script.render = render

export default script